// extracted by mini-css-extract-plugin
export var cardDetailedInfo = "blog-post-card-module--card-detailed-info--Wf20D";
export var cardDetailedInfoIcon = "blog-post-card-module--card-detailed-info-icon--ck9Vh";
export var cardDetailedInfoText = "blog-post-card-module--card-detailed-info-text--RsAif";
export var cardImage = "blog-post-card-module--card-image--KDVgG";
export var cardInfo = "blog-post-card-module--card-info--fWh-k";
export var cardInfoHeader = "blog-post-card-module--card-info-header--DraYY";
export var cardTitle = "blog-post-card-module--card-title--2pDgq";
export var container = "blog-post-card-module--container--k4Oq6";
export var detailsAuthor = "blog-post-card-module--details-author--eEhhs";
export var detailsCategories = "blog-post-card-module--details-categories--QBCwi";
export var detailsCategoriesIcon = "blog-post-card-module--details-categories-icon--TUSeA";
export var detailsCategoriesText = "blog-post-card-module--details-categories-text--8vF4D";
export var detailsIcon = "blog-post-card-module--details-icon--DwoOz";
export var detailsName = "blog-post-card-module--details-name--v-x2F";
export var publishDateContainer = "blog-post-card-module--publish-date-container--oj9Ds";
export var readMore = "blog-post-card-module--read-more--xIC2S";
export var readTime = "blog-post-card-module--read-time--7XrdG";